// @flow
import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { styled } from '@mui/material/styles';
import { GlobalEvent, GlobalState } from './GlobalContext'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DocDListGridEdit from './DocDListGridEdit';
import SelMemberDialog from './SelMemberDialog';
import MsgDialog from './MsgDialog';
import OCRTextDialog from './OCRTextDialog';
import Backdrop from '@mui/material/Backdrop';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { useForm, Controller } from "react-hook-form";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import CircularProgress from '@mui/material/CircularProgress';
import DatePicker from '@mui/lab/DatePicker';
import Accordion from '@mui/material/Accordion';
import EditIcon from '@mui/icons-material/Edit';
import DocPermissionEditDialog from './DocPermissionEditDialog';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Alert from '@mui/material/Alert';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import GroupIcon from '@mui/icons-material/Group';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Stage, Layer, Rect, Image as KonvaImage } from "react-konva";
// import useImage from 'use-image';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';

import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';


import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';

import PropTypes from 'prop-types';
import CssBaseline from '@mui/material/CssBaseline';

import dayjs from 'dayjs';


const highlightStyle = { background: "rgb(245, 238, 37)" };

const OPTION_SUBJECT = "Subject";
const OPTION_DOC_REF = "Doc Ref";
const OPTION_OUR_REF = "Our Ref No";
const OPTION_FILE_LOC = "File Location";
const OPTION_SENDER = "Sender";
const OPTION_COMPANY = "Company / Department";
const OPTION_RECIPIENT = "Recipient";
const OPTION_KEYWORDS = "Keywords";

function Dropdown(props) {
  const { value, onChange, onDelete, onChanged } = props;

  const state = useMemo(() => ({
    options: [
      { value: OPTION_SUBJECT, label: OPTION_SUBJECT },
      { value: OPTION_DOC_REF, label: OPTION_DOC_REF },
      { value: OPTION_OUR_REF, label: OPTION_OUR_REF },
      { value: OPTION_FILE_LOC, label: OPTION_FILE_LOC },
      { value: OPTION_SENDER, label: OPTION_SENDER },
      { value: OPTION_COMPANY, label: OPTION_COMPANY },
      { value: OPTION_RECIPIENT, label: OPTION_RECIPIENT },
      { value: OPTION_KEYWORDS, label: OPTION_KEYWORDS },
    ],
  }), []);

  // const [selectedOption, setSelectedOption] = useState('');

  // console.log("Dropdown value", value);
  // console.log("Dropdown selectedOption", selectedOption);

  // useEffect(() => {
  //   console.log("Dropdown[did mount]")
  // },[])

  const handleChange = (event) => {
    const aVal = event.target.value;
    // console.log("aVal", aVal);
    // setSelectedOption(aVal);

    onChange && onChange(aVal);

    onChanged && onChanged();
  };

  const handleDelete = () => {
    onDelete && onDelete();
  }


  return (

    <Box sx={{ py: 0, px: 1, flexDirection: 'column', width: '300px', bgcolor: 'white' }} >
      <Select
        labelId="ocr-annotation-label"
        id="ocr-annotation"
        value={value}
        onChange={handleChange}
        sx={{ width: '220px' }}
        size="small"
      >
        {state.options.map((item, idx) => (
          <MenuItem key={idx} value={item.value}>{item.label}</MenuItem>
        ))}
      </Select>

      <IconButton aria-label="delete" onClick={handleDelete}>
        <DeleteIcon />
      </IconButton>
    </Box>

  );

}

Dropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
  onChanged: PropTypes.func,
};

// const LionImage = () => {
//   const [image] = useImage('https://konvajs.org/assets/lion.png');
//   return (<KonvaImage image={image} />);
// };


function URLImage(props) {
  const { src, x, y } = props;

  // console.log(`URLImage x: ${x} y: ${y} `)

  const imageRef = useRef(null);
  const [image, setImage] = useState(null);

  useEffect(() => {
    loadImage();

    return () => {
      if (imageRef.current) {
        imageRef.current.removeEventListener('load', handleLoad);
      }
    }
  }, []);

  useEffect(() => {

    loadImage();
  }, [src]);

  const loadImage = () => {
    // console.log('loadImage', src);

    const vImage = new window.Image();
    vImage.src = src;
    vImage.crossOrigin = "Anonymous";

    imageRef.current = vImage;
    imageRef.current.addEventListener('load', handleLoad);

  }

  const handleLoad = () => {
    // console.log('handleLoad', imageRef.current);
    setImage(imageRef.current);
  }

  return (
    <KonvaImage
      x={x}
      y={y}
      image={image}
    />
  );
}

URLImage.propTypes = {
  src: PropTypes.string,
  x: PropTypes.number,
  y: PropTypes.number,
};


export default function UploadSingleFileDialog(props) {

  const { sysID, folderID, open, iniFile, useBlankFile, onClose, onAfterUpload, onError } = props;

  const docTypes = props.docTypes || [];

  const $ = document.querySelector.bind(document);

  const filesLimit = 30;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const [selFiles, setSelFiles] = useState([]);
  const [disabledUpload, setDisabledUpload] = useState(true);

  const [showLoading, setShowLoading] = useState(false);
  const [showAIAnalyzing, setShowAIAnalyzing] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [distData, setDistData] = useState([]);
  const [highlightFields, setHighlightFields] = useState({});

  const [anchorElAdd, setAnchorElAdd] = useState(null);
  const openAddDialog = Boolean(anchorElAdd);

  const onCatchPromiseError = (e) => {
    const msg = typeof e === "string" ? e : (e?.errMsg || e?.message || "Unknown Error");
    setErrMsg(msg);
    setShowError(true);
    gEventDispatch({
      showErr: true,
      err: e,
    });
  }

  const handleAddClick = (event) => {
    setAnchorElAdd(event.currentTarget);
  };
  const handleCloseAddMenu = () => {
    setAnchorElAdd(null);
  };

  const [openAddDistUserDialog, setOpenAddDistUserDialog] = useState(false);
  const [allFolderUsers, setAllFolderUsers] = useState([]);
  // const [members, setMembers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [imgFile, setImgFile] = useState(null);

  useEffect(() => {

    if (open === true) {
      initData();

      const xFunc = async () => {
        try {
          const [vAllFolderUsers, , vGroups] =
            await DmsService.getFolderAccessibleUsersPromise(gState.sessionID, sysID, folderID);
          setAllFolderUsers(vAllFolderUsers);
          // setMembers(vMembers);
          setGroups(vGroups);


          if (!useBlankFile && iniFile) {
            setValue("fileName", iniFile.name);
            setValue("subject", (iniFile.name || "").substring(0, 200));

            handleSetFile(iniFile);
          }
        } catch (e) {
          onCatchPromiseError(e);
        }



      }
      xFunc();

    }

  }, [open])


  const handleAddDistUserClick = async () => {
    setAnchorElAdd(null);

    setOpenAddDistUserDialog(true);

  };


  const handleSelectAddDistUsers = (aUsers, aGroups) => {
    // console.log("aUsers", aUsers);
    // console.log("aGroups", aGroups);

    setOpenAddDistUserDialog(false);

    let vData = distData.map(item => {
      return item
    });


    aUsers.forEach(addUser => {
      const vFound = vData.find(f => f.ToUserID.toLowerCase() === addUser.UserID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "ActionReq": 0,
          "DeptName": addUser.Department,
          "ToUserID": addUser.UserID,
          "ToUserName": addUser.FullName,
          "IsUser": true,
        }

        vData.push(vNewItem);

      }
    });

    aGroups.forEach(addGroup => {
      const vFound = vData.find(f => f.ToUserID.toLowerCase() === addGroup.GroupID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "ActionReq": 0,
          "DeptName": "",
          "ToUserID": addGroup.GroupID,
          // "ToUserName": addGroup.GroupNameDisplay,
          "ToUserName": addGroup.Name,
          "IsUser": false,
        }

        vData.push(vNewItem);

      }
    });

    // console.log("vData", vData);
    setDistData(vData);
    setSelectedDistRecs([]);

  }


  const handleSelectAddPermissionUsers = (aUsers, aGroups) => {
    // console.log("aUsers", aUsers);
    // console.log("aGroups", aGroups);

    setOpenAddPermissionUserDialog(false);

    let vData = permissionData.map(item => {
      return item
    });

    aUsers.forEach(addUser => {
      const vFound = vData.find(f => f.UserOrGroupID.toLowerCase() === addUser.UserID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "DeptName": addUser.Department,
          "UserOrGroupID": addUser.UserID,
          "Name": addUser.FullName,
          "Description": "",
          "IsUser": true,
        }

        vData.push(vNewItem);
      }
    });

    aGroups.forEach(addGroup => {
      const vFound = vData.find(f => f.UserOrGroupID.toLowerCase() === addGroup.GroupID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "DeptName": "",
          "UserOrGroupID": addGroup.GroupID,
          // "Name": addGroup.GroupNameDisplay,
          "Name": addGroup.Name,
          "Description": addGroup.Desc,
          "IsUser": false,
        }

        vData.push(vNewItem);
      }
    });

    // console.log("vData", vData);
    setPermissionData(vData);
    setSelectedPermissionRecs([]);

  }



  const handleAddAllAuthDistUsers = async () => {
    setAnchorElAdd(null);

    setShowLoading(true);

    try {

      let vData = distData.map(item => {
        return item
      });

      let vHasUpdate = false;

      allFolderUsers.forEach(addUser => {
        const vFound = vData.find(f => f.ToUserID.toLowerCase() === addUser.UserID.toLowerCase());
        if (!vFound) {
          // console.log("addUser", addUser);
          const vNewItem = {
            "ActionReq": 0,
            "DeptName": addUser.Department,
            "ToUserID": addUser.UserID,
            "ToUserName": addUser.FullName,
            "IsUser": true,
          }

          vData.push(vNewItem);

          vHasUpdate = true;
        }
      });

      if (vHasUpdate === true) {
        // console.log("vData", vData);
        setDistData(vData);
        setSelectedDistRecs([]);
      }

      setShowLoading(false);
    } catch (e) {
      setShowLoading(false);
      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);
    };





  };



  const handleActionChange = (aRecord, aNewValue) => {
    // console.log("handleActionChange", aCurIdx, aNewValue);

    const vNewGridData = distData.map((d, idx) => {
      if (d.ToUserID == aRecord.ToUserID) {
        return {
          ...d,
          "ActionReq": aNewValue,
        }
      } else {
        return d;
      }
    });

    setDistData(vNewGridData);
  };

  const handleRemoveDist = () => {
    // console.log("handleRemoveDist selectedDistRecs", selectedDistRecs);

    const vData = distData.filter(d => !selectedDistRecs.some(r => r.ToUserID === d.ToUserID));
    setDistData(vData);
    setSelectedDistRecs([]);

  }




  const [selectedDistRecs, setSelectedDistRecs] = useState([]);

  const handleDistSelectionChange = (aRecords) => {

    setSelectedDistRecs(aRecords);

  }



  const [file, setFile] = useState(null);
  const [isOcrImg, setIsOcrImg] = useState(false);

  const handleSelectedUploadFile = (e) => {
    const vFileList = e.target.files;
    // console.log("handleSelectedUploadFile", vFileList);

    if (vFileList.length > 0) {
      const vFile = vFileList[0];

      // setFileName(vFile.name);
      setValue("fileName", vFile.name);

      if (getValues("subject") == "") {
        setValue("subject", (vFile.name || "").substring(0, 200));
      }

      handleSetFile(vFile);
    }

  }

  // Setup inital form values
  const defaultFormValues = {
    fileName: "",

    folderID: 0,
    folderPath: "",
    docDate: null,
    docRef: "",
    docType: "",
    // docTypeCodes: [],
    ourRef: "",
    subject: "",
    recDate: null,
    fileLoc: "",
    RFID: "",
    sender: "",
    keywords: "",
    compDept: "",
    recipient: "",

    fileSeq: 0,
  }

  // React Hook the form
  const { control, handleSubmit, setValue, getValues, watch } = useForm({
    defaultValues: defaultFormValues
  });


  const [selectedDocTypes, setSelectedDocTypes] = useState([]);

  const handleChangeDocType = (event) => {
    setSelectedDocTypes(event.target.value);
  };


  const [imgSize, setImgSize] = useState({ width: 300, height: 300 });
  const [imgViewBox, setImgViewBox] = useState("0 0 0 0");



  const [infoGridSize, setInfoGridSize] = useState(12);
  const [annotationData, setAnnotationData] = useState([]);


  const [annotations, setAnnotations] = useState([]);
  const [newAnnotation, setNewAnnotation] = useState([]);


  const handleMouseDown = event => {
    if (newAnnotation.length === 0) {
      const { x, y } = event.target.getStage().getPointerPosition();
      setNewAnnotation([{ x, y, width: 0, height: 0, key: "0" }]);
    }

  };

  const [openOCRTextDialog, setOpenOCRTextDialog] = useState(false);
  const [ocrText, setOcrText] = useState("");
  const [ocrOptions] = useState([
    { label: OPTION_SUBJECT },
    { label: OPTION_DOC_REF },
    { label: OPTION_OUR_REF },
    { label: OPTION_FILE_LOC },
    { label: OPTION_SENDER },
    { label: OPTION_COMPANY },
    { label: OPTION_RECIPIENT },
    { label: OPTION_KEYWORDS },
  ]);

  const handleOCRSelect = (aSelectedOption, aText) => {
    // console.log("aSelectedOption", aSelectedOption);

    setOpenOCRTextDialog(false);


    switch (aSelectedOption) {
      case OPTION_SUBJECT:
        setValue("subject", (aText || "").substring(0, 200));
        break;
      case OPTION_DOC_REF:
        setValue("docRef", aText);
        break;
      case OPTION_OUR_REF:
        setValue("ourRef", aText);
        break;
      case OPTION_FILE_LOC:
        setValue("fileLoc", aText);
        break;
      case OPTION_SENDER:
        setValue("sender", aText);
        break;
      case OPTION_COMPANY:
        setValue("compDept", aText);
        break;
      case OPTION_RECIPIENT:
        setValue("recipient", aText);
        break;
      case OPTION_KEYWORDS:
        setValue("keywords", aText);
        break;
    }
  }

  const handleMouseUp = async (event) => {

    setShowLoading(true);
    try {


      if (newAnnotation.length === 1) {

        let vFileID = ocrFileID;
        if (vFileID == null) {
          vFileID = await uploadFile(file);
          setOcrFileID(vFileID);
        }

        const vBoundBoxes = []

        const d = newAnnotation[0];
        const x1 = d.x;
        const x2 = d.x + d.width;
        const y1 = d.y;
        const y2 = d.y + d.height;

        if (x1 !== x2 && y1 !== y2) {
          const vBoundBox = {
            id: d.key,
            p1: {
              x: Math.min(x1, x2),
              y: Math.min(y1, y2),
            },
            p2: {
              x: Math.max(x1, x2),
              y: Math.max(y1, y2),
            },
          };
          vBoundBoxes.push(vBoundBox);

          // console.log('vBoundBoxes', vBoundBoxes);

          const vOCR_Rst = await DmsService.imgOCR_Promise(gState.sessionID, vFileID, vBoundBoxes);

          // console.log("vOCR_Rst", vOCR_Rst);

          if (vOCR_Rst.length === 1) {
            const vOcrStr = vOCR_Rst[0].String.replace(/[\n\r]/g, ' ');
            setOcrText(vOcrStr);

            setOpenOCRTextDialog(true);
          }
        }



        setNewAnnotation([]);
        setAnnotations([]);

      }

      setShowLoading(false);

    } catch (e) {
      setShowLoading(false);
      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);
    };

  };

  const handleMouseMove = event => {
    if (newAnnotation.length === 1) {
      const sx = newAnnotation[0].x;
      const sy = newAnnotation[0].y;
      const { x, y } = event.target.getStage().getPointerPosition();
      setNewAnnotation([
        {
          x: sx,
          y: sy,
          width: x - sx,
          height: y - sy,
          key: "0"
        }
      ]);
    }

  };

  const annotationsToDraw = [...annotations, ...newAnnotation];

  const clearAutoFilledField = () => {
    if (highlightFields.subject === true) { setValue("subject", "") };
    if (highlightFields.sender === true) { setValue("sender", "") };
    if (highlightFields.recipient === true) { setValue("recipient", "") };
    if (highlightFields.docRef === true) { setValue("docRef", "") };
    if (highlightFields.compDept === true) { setValue("compDept", "") };
    if (highlightFields.docDate === true) { setValue("docDate", dayjs().startOf('date')) };
    if (highlightFields.keywords === true) { setValue("keywords", "") };

    // if (highlightFields.docTypeCodes === true) { setValue("docTypeCodes", []) };
    if (highlightFields.docTypeCodes === true) { setSelectedDocTypes([]) };

    setHighlightFields({});
  }

  const handleSetFile = (aFile) => {
    setFile(aFile);
    if (aFile && aFile.size > DmsCommon.MAX_FILE_SIZE) {
      setIsOcrImg(false);
      setOcrFileID(null);
      setAnnotationData([]);
      return;
    }

    const aFunc = async () => {

      setShowLoading(true);
      try {
        // console.log("iniFile", aFile);
        // console.log("iniFile.height()", iniFile.height());
        // console.log("iniFile", iniFile);

        setFile(aFile);

        const vFileExt = DmsCommon.getFileExtension(aFile.name).toLowerCase();
        // console.log("vFileExt", vFileExt);


        const vCanOCR = ['.jpg', '.jpeg', '.bmp', '.gif', '.png'].includes(vFileExt);

        // console.log("vCanOCR", vCanOCR);

        setIsOcrImg(vCanOCR);
        setOcrFileID(null);
        setAnnotationData([]);

        if (vCanOCR === true) {

          const imgURL = URL.createObjectURL(aFile);
          // console.log("imgURL", imgURL);
          setImgFile(imgURL);
          setInfoGridSize(4);

          // Find Width & Height of image, and set it accordingly
          const img = new window.Image();
          img.onload = function () {
            // console.log("width", this.width);
            // console.log("height", this.height);

            setImgSize({ width: this.width, height: this.height });
            setImgViewBox(`0 0 ${this.width} ${this.height}`)


          };
          img.src = imgURL;



        } else {
          setImgFile(null);
          setInfoGridSize(12);
        }


      } finally {
        setShowLoading(false);
      }

      setShowAIAnalyzing(true);
      try {


        clearAutoFilledField();

        const vFileExt = DmsCommon.getFileExtension(aFile.name).toLowerCase();

        // Get AI file prompt
        const vCanFilePromptExt = ['.pdf', '.doc', '.docx', '.jpeg', '.jpg', '.gif', '.png', '.bmp', 'tif', 'tiff'].includes(vFileExt);
        if (vCanFilePromptExt && aFile.size <= 1024 * 1024 * 20) {
          // const vFileID = DmsCommon.CreateFileID();
          // await DmsService.uploadFilePromise(gState.sessionID, aFile, vFileID, 1);

          // const docTypeDescList = docTypes.map((d) => d.RefCodeDesc).join(", ");
          // const vPrompt =
          //   "Find the subject, date, sender, recipient, document type " +
          //   `(from [${docTypeDescList}]), ` +
          //   "reference number, company and keywords (max. 5) of this document. Return in json " +
          //   "format. For any date value, change it into ISO format";
          // console.log("vPrompt", vPrompt);

          let promptRst;
          const fileSeq = getValues("fileSeq");
          try {

            promptRst = await DmsService.dmsFilePrompt_Promise(gState.sessionID, sysID, aFile);

          } catch (e) {

            console.log(`dmsFilePrompt_Promise: ${e.errMsg || e.message}`)
          };

          // Use fileSeq to control if ai analyzing is cancelled, if fileSeq changed
          // (by cancelling the analyze), fileSeq will be changed
          const curFileSeq = getValues("fileSeq");

          if (promptRst && promptRst.dataj && fileSeq === curFileSeq) {
            // console.log("promptRst", promptRst.dataj);

            const j = promptRst.dataj;

            const newHighlights = {};

            if (j.subject) {
              setValue("subject", (j.subject || "").substring(0, 200));
              newHighlights.subject = true;
            }

            let vSenderName = j["sender_name"];
            if (!(vSenderName)) { vSenderName = j["sender name"]; }
            if (vSenderName) {
              setValue("sender", vSenderName);
              newHighlights.sender = true;
            }

            let vRecipientName = j["recipient_name"];
            if (!(vRecipientName)) { vRecipientName = j["recipient name"]; }
            if (vRecipientName) {
              setValue("recipient", vRecipientName);
              newHighlights.recipient = true;
            }

            let vRefNumber = j["reference_number"];
            if (!(vRefNumber)) { vRefNumber = j["reference number"]; }
            if (vRefNumber) {
              setValue("docRef", vRefNumber);
              newHighlights.docRef = true;
            }

            if (j.company) {
              setValue("compDept", j.company);
              newHighlights.compDept = true;
            }

            let vDocTypeDesc = j["document_type"];
            if (!(vDocTypeDesc)) { vDocTypeDesc = j["document type"]; }
            // console.log("vDocTypeDesc:", vDocTypeDesc);
            if (vDocTypeDesc) {

              const vDocTypes = [];
              docTypes.map((d) => {
                if (d.RefCodeDesc == vDocTypeDesc) {
                  // vDocTypes.push(d.RefCode);
                  vDocTypes.push(d);
                }
              });
              // setValue('docTypeCodes', vDocTypes);
              // console.log("Document Types:", vDocTypes);
              setSelectedDocTypes(vDocTypes);
              newHighlights.docTypeCodes = true;
            }

            if (j.date) {
              // console.log("j.date", j.date);
              try {
                const vDocDate = dayjs(j.date);
                // console.log("vDocDate", vDocDate);
                if (vDocDate) {
                  setValue("docDate", vDocDate);
                  newHighlights.docDate = true;
                }
              } catch (e) {
              };
            }
            if (j.keywords && j.keywords.length > 0) {
              setValue("keywords", j.keywords.join("\n"));
              newHighlights.keywords = true;
            }

            setHighlightFields(newHighlights);

          }
        }


      } finally {
        setShowAIAnalyzing(false);
      }

    }
    aFunc();



  }


  const initData = () => {

    setHighlightFields({});
    setFile(null);
    setImgFile(null);
    setOcrFileID(null);


    setValue("fileName", "");

    setValue("folderID", folderID);
    setValue("folderPath", "");
    setValue("subject", "");
    setValue("docDate", dayjs().startOf('date'));
    setValue("docRef", "");
    setValue("docType", "");
    setValue("ourRef", "");
    setValue("recDate", null);
    setValue("fileLoc", "");
    setValue("RFID", "");
    setValue("sender", "");
    setValue("keywords", "");
    setValue("compDept", "");
    setValue("recipient", "");

    // setValue("docTypeCodes", []);
    setSelectedDocTypes([]);

    setDistData([]);
    setSelectedDistRecs([]);

    setIsAllFolderUsers(true);
    setPermissionData([]);
    setSelectedPermissionRecs([]);

  }

  const onSubmit = data => {
    // console.log("onSubmit", data);
    // console.log("onSubmit distData", distData);
    // console.log("onSubmit permissionData", permissionData);


    const xFunc = async () => {
      try {
        // console.log("useBlankFile", useBlankFile);

        const docDateISO = data.docDate?.format(DmsCommon.ISO_DATETIME_FORMAT) || "";
        const recDateISO = data.recDate?.format(DmsCommon.ISO_DATETIME_FORMAT) || "";

        const docTypeCodes = selectedDocTypes.map((d) => d.RefCode);

        if (useBlankFile === true) {
          setShowLoading(true);

          const vDistList = distData.map(d => {
            return {
              "UserID": d.ToUserID,
              "ActionReq": d.ActionReq,
            }
          })

          let vPermUserList = [];

          if (isAllFolderUsers === true) {
            vPermUserList = ['*'];
          } else {
            vPermUserList = permissionData.map(d => {
              return d.UserOrGroupID
            })

          }



          await DmsService.docAddPromise(gState.sessionID, sysID, folderID, data.subject,
            docDateISO, docTypeCodes, data.sender, data.compDept, data.recipient,
            data.docRef, data.ourRef, data.fileLoc, data.keywords, data.RFID, recDateISO,
            "", "", -1, [], vDistList, vPermUserList, useBlankFile);

          setShowLoading(false);
          setOpenUploadProgress(false);

          onAfterUpload && onAfterUpload();
        } else {
          if (file && file.size > DmsCommon.MAX_FILE_SIZE) {
            setErrMsg("File size exceeds 2GB limit!");
            setShowError(true);
            return;
          }
          setUploadProgress(0);
          setOpenUploadProgress(true);
          setShowLoading(true);

          const aFileID = await uploadFile(file);

          const vDistList = distData.map(d => {
            return {
              "UserID": d.ToUserID,
              "ActionReq": d.ActionReq,
            }
          })

          let vPermUserList = [];

          if (isAllFolderUsers === true) {
            vPermUserList = ['*'];
          } else {
            vPermUserList = permissionData.map(d => {
              return d.UserOrGroupID
            })

          }

          const docDateISO = data.docDate?.format(DmsCommon.ISO_DATETIME_FORMAT) || "";
          const recDateISO = data.recDate?.format(DmsCommon.ISO_DATETIME_FORMAT) || "";

          setUploadStatusText("Creating document...");
          await DmsService.docAddPromise(gState.sessionID, sysID, folderID, data.subject,
            docDateISO, docTypeCodes, data.sender, data.compDept, data.recipient,
            data.docRef, data.ourRef, data.fileLoc, data.keywords, data.RFID, recDateISO,
            aFileID, file.name, file.size, [], vDistList, vPermUserList);

          setShowLoading(false);
          setUploadStatusText("");
          setOpenUploadProgress(false);

          onAfterUpload && onAfterUpload();
        }


      } catch (e) {

        setShowLoading(false);
        setUploadStatusText("");
        setOpenUploadProgress(false);

        console.log('Fail: ', e);

        onCatchPromiseError(e);
      }

    }
    xFunc();


  }


  const [openUploadProgress, setOpenUploadProgress] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatusText, setUploadStatusText] = useState("");

  const uploadFile = async (aFile) => {
    if (!aFile || aFile.size === 0) return "";
    if (aFile.size > DmsCommon.MAX_FILE_SIZE) {
      throw new Error("File size exceeds 2GB limit!");
    }
    setUploadProgress(0);
    setUploadStatusText("Uploading file: 0%");
    const vFileID = await DmsService.uploadChunkedFilePromise(
      gState.sessionID,
      aFile,
      (progress) => {
        setUploadProgress(progress);
        setUploadStatusText(`Uploading file: ${Math.round(progress)}%`);
      },
      DmsCommon.UPLOAD_CONCURRENCY || 4,
      (status) => {
        if (status === "assembling") {
          setUploadStatusText("Assembling file on server...");
        }
      }
    );
    return vFileID;
  }

  const [ocrFileID, setOcrFileID] = useState(null)


  const [isAllFolderUsers, setIsAllFolderUsers] = useState(true);

  const handleRangeChange = (event) => {
    setIsAllFolderUsers(event.target.value === "0")
  }

  const [selectedPermissionRecs, setSelectedPermissionRecs] = useState([]);
  const [permissionData, setPermissionData] = useState([]);

  const handleRemovePermission = () => {
    // console.log("handleRemoveDist selectedDistRecs", selectedDistRecs);

    const vData = permissionData.filter(d => !selectedPermissionRecs.some(r => r.UserOrGroupID === d.UserOrGroupID));
    setPermissionData(vData);
    setSelectedPermissionRecs([]);
  }

  const [openAddPermissionUserDialog, setOpenAddPermissionUserDialog] = useState(false);

  const handleAddPermissionUser = async () => {

    setOpenAddPermissionUserDialog(true);

  };

  const onPermissionSelectionChanged = (params) => {
    // console.log('Selection Changed', params);
    let nodes = params.api.getSelectedNodes();
    // console.log('Selected nodes', nodes);

    let selRecs = nodes.map(item => {
      return item.data
    });

    setSelectedPermissionRecs(selRecs);

  }

  const handleCloseClick = () => {

    onClose && onClose();
  }

  const handleCancelAIClick = () => {

    const fileSeq = getValues("fileSeq");
    setValue("fileSeq", fileSeq + 1);

    setShowAIAnalyzing(false);
  }

  const submitBtnRef = useRef();

  const handleFormSubmit = () => {
    submitBtnRef?.current?.click();
  }

  const handleClearAutoFill = () => {
    // console.log('handleClearAutoFill');
    clearAutoFilledField();
  }

  const [pageSize, setPageSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const onResize = () => {
    setPageSize({ width: window.innerWidth, height: window.innerHeight });
  };

  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);


  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      {...props}
    />
  ))(({ theme }) => ({
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, .05)'
        : 'rgba(0, 0, 0, .03)',
  }));


  const myTheme = {
    // Theme object to extends default dark theme.
  };

  const hasAutoFill = Object.keys(highlightFields).length > 0;

  const Input = styled('input')({
    display: 'none',
  });

  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };

  const UserTypeRenderer = (params) => {
    return (

      <IconButton color="primary" aria-label="upload picture" component="span">
        {params.value === true && <AccountCircleIcon />}
        {params.value !== true && <GroupIcon />}
      </IconButton>
    )
  }
  const permColumnDefs = useMemo(() => [
    { field: 'IsUser', headerName: " ", cellStyle: cellStyle, width: 50, cellRenderer: UserTypeRenderer, },
    { field: 'Name', headerName: "Username", cellStyle: cellStyle, minWidth: 150, flex: "1", headerCheckboxSelection: true, checkboxSelection: true, },
    { field: 'DeptName', headerName: "Department", cellStyle: cellStyle, minWidth: 150, flex: "1", },
    { field: 'Desc', headerName: "Description", cellStyle: cellStyle, minWidth: 150, flex: "1", },
  ], []);

  return (
    <React.Fragment>
      <CssBaseline />
      <Dialog
        fullScreen
        maxWidth="xl"
        open={open}
        // onClose={handleCloseClick}
        aria-describedby="upload-single-dialog-description"

      // scroll="paper"
      // PaperProps={{
      //   sx: {
      //     display: 'flex',
      //     minHeight: "90vh",
      //     maxHeight: "90vh",
      //   }
      // }}
      >
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
          open={showLoading}
        >
          <CircularProgress color="inherit" />
          {uploadStatusText && (
            <Typography variant="h6" component="div" sx={{ fontWeight: 500 }}>
              {uploadStatusText}
            </Typography>
          )}
        </Backdrop>
        <MsgDialog
          open={showError}
          title="Error"
          msgText={errMsg}
          onClose={() => setShowError(false)}
        />

        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showAIAnalyzing}
        >
          <Grid container spacing={1}  >

            <Grid item xs={12}

              sx={{ display: 'flex', justifyContent: 'center' }}
            >
              Analyzing document...
              <CircularProgress color="inherit" sx={{ ml: 1 }} />
            </Grid>
            <Grid item xs={12}
              sx={{ display: 'flex', justifyContent: 'center' }}
            >
              <Button sx={{ display: "block" }}
                variant="contained" size="small" onClick={handleCancelAIClick} >
                Cancel
              </Button>
            </Grid>
          </Grid>





        </Backdrop>

        <SelMemberDialog
          open={openAddDistUserDialog}
          onClose={() => { setOpenAddDistUserDialog(false) }}
          members={allFolderUsers}
          groups={groups}
          onSelect={handleSelectAddDistUsers}
        />

        <SelMemberDialog
          open={openAddPermissionUserDialog}
          onClose={() => { setOpenAddPermissionUserDialog(false) }}
          members={allFolderUsers}
          groups={groups}
          onSelect={handleSelectAddPermissionUsers}
        />

        <DialogTitle>Upload File</DialogTitle>
        <DialogContent>

          <Box sx={{ display: 'flex', flexDirection: 'column', height: "80vh", mt: 1 }} component="form" onSubmit={handleSubmit(onSubmit)} >
            <Grid container spacing={1}  >

              {isOcrImg &&

                <Grid item xs={8} sx={{ display: 'flex', overflow: 'auto', maxHeight: "70vh", border: 1 }}  >
                  <Stage
                    onMouseDown={handleMouseDown}
                    onMouseUp={handleMouseUp}
                    onMouseMove={handleMouseMove}
                    width={imgSize.width}
                    height={imgSize.height}
                  >
                    <Layer>
                      <URLImage
                        src={imgFile}
                      />
                      {annotationsToDraw.map(value => {
                        return (
                          <Rect
                            key={value.key}
                            x={value.x}
                            y={value.y}
                            width={value.width}
                            height={value.height}
                            fill="transparent"
                            stroke="red"
                          />
                        );
                      })}
                    </Layer>
                  </Stage>

                  <OCRTextDialog
                    open={openOCRTextDialog}
                    onClose={() => setOpenOCRTextDialog(false)}
                    onSelect={handleOCRSelect}
                    ocrText={ocrText}
                    options={ocrOptions}
                  />
                </Grid>
              }

              <Grid item xs={infoGridSize} container spacing={1} >

                <Grid item xs={12}>
                  <Controller
                    name="fileName"
                    control={control}
                    render={({ field }) =>
                      <TextField
                        label="File"
                        required={!useBlankFile}
                        disabled={useBlankFile}
                        fullWidth
                        // variant="standard"
                        size="small"
                        {...field}
                        InputLabelProps={{ shrink: true, }}
                        InputProps={{
                          readOnly: true,
                          endAdornment:
                            <InputAdornment position="end">
                              <label htmlFor="icon-button-upload-file">
                                <Input id="icon-button-upload-file" type="file" onChange={handleSelectedUploadFile} />
                                <Button variant="contained" component="span" size="small"
                                  disabled={useBlankFile}
                                >
                                  Select
                                </Button>
                              </label>
                            </InputAdornment>
                        }}
                      />

                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <Controller
                    name="subject"
                    control={control}
                    render={({ field }) =>
                      <TextField
                        required
                        label="Subject"
                        variant={highlightFields.subject ? "filled" : "standard"}
                        InputProps={{ style: highlightFields.subject ? highlightStyle : undefined }}
                        inputProps={{ maxLength: 200 }}
                        size="small"
                        fullWidth

                        {...field}

                        InputLabelProps={{ shrink: true, }}
                      />}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <Controller
                    name="docDate"
                    control={control}
                    render={({ field }) =>
                      <DatePicker
                        label="Document Date"
                        type="date"
                        inputFormat={DmsCommon.SHORT_DATE_FORMAT}
                        variant={highlightFields.docDate ? "filled" : "standard"}
                        InputProps={{ style: highlightFields.docDate ? highlightStyle : undefined }}
                        {...field}
                        renderInput={(params) => <TextField
                          variant="standard"
                          size="small"
                          required
                          fullWidth
                          {...params}
                          InputLabelProps={{ shrink: true, }}
                        />}
                      />}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <Controller
                    name="recDate"
                    control={control}
                    render={({ field }) =>
                      <DatePicker
                        label="Receive Date"
                        type="date"
                        inputFormat={DmsCommon.SHORT_DATE_FORMAT}
                        {...field}
                        renderInput={(params) => <TextField
                          variant="standard"
                          size="small"
                          fullWidth
                          // format="dd-MM-yyyy"
                          {...params}

                          InputLabelProps={{ shrink: true, }}
                        />}
                      />}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="docRef"
                    control={control}
                    render={({ field }) =>
                      <TextField
                        label="Doc Ref"
                        variant={highlightFields.docRef ? "filled" : "standard"}
                        InputProps={{ style: highlightFields.docRef ? highlightStyle : undefined }}
                        size="small"
                        fullWidth
                        {...field}

                        InputLabelProps={{ shrink: true, }}
                      />}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  {/* <Controller
                    name="docTypeCodes"
                    control={control}
                    render={({ field }) =>
                      <TextField
                        label="Document Types"
                        variant={highlightFields.docTypeCodes ? "filled" : "standard"}
                        InputProps={{ style: highlightFields.docTypeCodes ? highlightStyle : undefined }}
                        size="small"
                        select
                        SelectProps={{ "multiple": true }}
                        fullWidth
                        {...field}
                        InputLabelProps={{ shrink: true, }}
                      >
                        {docTypes.map((d) => (
                          <MenuItem
                            key={d.RefCode}
                            value={d.RefCode}
                          >
                            {d.RefCodeDesc}
                          </MenuItem>
                        ))}
                      </TextField>

                    }
                  /> */}
                  <TextField
                    label="Document Types"
                    variant={highlightFields.docTypeCodes ? "filled" : "standard"}
                    value={selectedDocTypes}
                    InputProps={{ style: highlightFields.docTypeCodes ? highlightStyle : undefined }}
                    onChange={handleChangeDocType}
                    size="small"
                    select
                    SelectProps={{
                      multiple: true,
                      renderValue: (selected) => selected.map(f => f.RefCodeDesc).join(', '),
                    }}
                    fullWidth
                    InputLabelProps={{ shrink: true, }}
                  >
                    {docTypes.map((d) => (
                      <MenuItem key={d.RefCode} value={d} >
                        <Checkbox checked={selectedDocTypes.indexOf(d) > -1} />
                        <ListItemText primary={d.RefCodeDesc} />
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Controller
                    name="ourRef"
                    control={control}
                    render={({ field }) =>
                      <TextField
                        label="Our Ref No"
                        variant="standard"
                        size="small"
                        fullWidth
                        {...field}

                        InputLabelProps={{ shrink: true, }}
                      />}
                  />
                </Grid>


                <Grid item xs={12} sm={6} container spacing={1} >
                  <Grid item xs={12} >
                    <Controller
                      name="RFID"
                      control={control}
                      render={({ field }) =>
                        <TextField
                          label="RFID"
                          variant="standard"
                          size="small"
                          fullWidth
                          {...field}

                          InputLabelProps={{ shrink: true, }}
                        />}
                    />
                  </Grid>
                  <Grid item xs={12} >
                    <Controller
                      name="fileLoc"
                      control={control}
                      render={({ field }) =>
                        <TextField
                          label="File Location"
                          variant="standard"
                          size="small"
                          fullWidth
                          {...field}

                          InputLabelProps={{ shrink: true, }}
                        />}
                    />
                  </Grid>
                  <Grid item xs={12} >
                    <Controller
                      name="sender"
                      control={control}
                      render={({ field }) =>
                        <TextField
                          label="Sender"
                          variant={highlightFields.sender ? "filled" : "standard"}
                          InputProps={{ style: highlightFields.sender ? highlightStyle : undefined }}
                          size="small"
                          fullWidth
                          {...field}

                          InputLabelProps={{ shrink: true, }}
                        />}
                    />
                  </Grid>


                  <Grid item xs={12}  >
                    <Controller
                      name="compDept"
                      control={control}
                      render={({ field }) =>
                        <TextField
                          label="Company / Department"
                          variant={highlightFields.compDept ? "filled" : "standard"}
                          InputProps={{ style: highlightFields.compDept ? highlightStyle : undefined }}
                          size="small"
                          fullWidth
                          {...field}

                          InputLabelProps={{ shrink: true, }}
                        />}
                    />
                  </Grid>

                  <Grid item xs={12} >
                    <Controller
                      name="recipient"
                      control={control}
                      render={({ field }) =>
                        <TextField
                          label="Recipient"
                          variant={highlightFields.recipient ? "filled" : "standard"}
                          InputProps={{ style: highlightFields.recipient ? highlightStyle : undefined }}
                          size="small"
                          fullWidth
                          {...field}

                          InputLabelProps={{ shrink: true, }}
                        />}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Controller
                    name="keywords"
                    control={control}
                    render={({ field }) =>
                      <TextField
                        label="Keywords"
                        variant={highlightFields.keywords ? "filled" : "standard"}
                        InputProps={{ style: highlightFields.keywords ? highlightStyle : undefined }}
                        size="small"
                        fullWidth
                        multiline
                        minRows={10.2}
                        maxRows={10.2}
                        {...field}

                        InputLabelProps={{ shrink: true, }}
                      />}
                  />
                </Grid>

                <Grid item xs={12} >

                  {/* <Box sx={{ pt: 1, px: 0 }}  >
                    Distribution List
                  </Box> */}

                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      Distribution List
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box sx={{ py: 0, px: 1 }}  >
                        <Button
                          id="add-button"
                          aria-controls="add-menu"
                          aria-haspopup="true"
                          aria-expanded={openAddDialog ? 'true' : undefined}
                          startIcon={<PersonAddAlt1Icon />}
                          onClick={handleAddClick}
                        >
                          Add
                        </Button>
                        <Menu
                          id="add-menu"
                          anchorEl={anchorElAdd}
                          open={openAddDialog}
                          onClose={handleCloseAddMenu}
                          MenuListProps={{
                            'aria-labelledby': 'add-button',
                          }}
                        >
                          <MenuItem onClick={handleAddDistUserClick}>Users</MenuItem>
                          <MenuItem onClick={handleAddAllAuthDistUsers}>All Authorized Users</MenuItem>
                        </Menu>

                        <Button startIcon={<PersonRemoveIcon />} disabled={selectedDistRecs.length == 0} onClick={handleRemoveDist}>
                          Remove
                        </Button>


                      </Box>

                      <Box sx={{ display: 'flex', height: "250px" }} >
                        <DocDListGridEdit
                          gridData={distData}
                          onActionChange={handleActionChange}
                          onSelectChange={handleDistSelectionChange}
                        />

                      </Box>
                    </AccordionDetails>


                  </Accordion>

                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      Permission
                    </AccordionSummary>
                    <AccordionDetails>

                      <Box sx={{ py: 1, px: 1 }} >
                        <FormControl component="fieldset">

                          <RadioGroup
                            aria-label="range"
                            value={isAllFolderUsers ? "0" : "1"}
                            onChange={handleRangeChange}
                            name="radio-buttons-group-range"
                          >
                            <FormControlLabel value="0" control={<Radio />} label="Everyone who can access the folder" />
                            <FormControlLabel value="1" control={<Radio />} label="Limited groups/users" />
                          </RadioGroup>


                        </FormControl>

                      </Box>

                      <Box sx={{ py: 1, px: 1, display: isAllFolderUsers ? "none" : "block" }} >
                        <Button
                          id="add-button"
                          startIcon={<PersonAddAlt1Icon />}
                          onClick={handleAddPermissionUser}
                        >
                          Add
                        </Button>

                        <Button startIcon={<PersonRemoveIcon />} disabled={selectedPermissionRecs.length == 0} onClick={handleRemovePermission}>
                          Remove
                        </Button>

                      </Box>


                      <Box sx={{ display: 'flex', height: "200px", mb: 10 }} >
                        <div className="ag-theme-material" style={{ display: isAllFolderUsers ? "none" : "block", width: '100%', height: '100%', bgcolor: 'yellow' }}>
                          <AgGridReact

                            rowData={permissionData}

                            defaultColDef={{
                              width: 100,
                              resizable: true,
                              sortable: true,
                              suppressMovable: true,
                            }}
                            headerHeight={40}

                            suppressNoRowsOverlay
                            columnDefs={permColumnDefs}

                            rowSelection="multiple"
                            rowMultiSelectWithClick
                            onSelectionChanged={onPermissionSelectionChanged}

                          />
                        </div>


                      </Box>



                    </AccordionDetails>
                  </Accordion>

                  <Box sx={{ display: 'flex', height: "10px" }} >
                  </Box>
                </Grid>
              </Grid>


            </Grid>




            <Button type="submit"
              ref={submitBtnRef} sx={{ display: "none" }}
              variant="contained"
            // disabled={!file}
            >
              SubmitBtn
            </Button>

          </Box>



        </DialogContent>
        <DialogActions>
          {/* {isOcrImg &&
            <Button onClick={handleOCRClick}>OCR</Button>
          }
          <div style={{ flex: '1 0 0' }} /> */}
          <Button style={{ display: hasAutoFill ? "Block" : "None" }} onClick={handleClearAutoFill} >Clear</Button>
          <div style={{ flex: '1 0 0' }} />
          <Button onClick={handleCloseClick}>Cancel</Button>
          <Button variant="contained"
            // disabled={!file}
            onClick={handleFormSubmit}
          >Upload</Button>
        </DialogActions>
      </Dialog>

    </React.Fragment>

  );
}

UploadSingleFileDialog.propTypes = {
  sysID: PropTypes.string,
  folderID: PropTypes.number,
  open: PropTypes.bool,
  iniFile: PropTypes.object,
  useBlankFile: PropTypes.bool,
  docTypes: PropTypes.array,
  onClose: PropTypes.func,
  onAfterUpload: PropTypes.func,
  onError: PropTypes.func,
};


